// Module Name
export const name = 'services';

export const typeServices = {
    GET_SERVICES: `${name}/GET_SERVICES`,
    GET_SERVICES_ETA: `${name}/GET_SERVICES_ETA`,
    GET_NAMEBOARD: `${name}/GET_NAMEBOARD`,
};
